var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1844 22.8739C11.3756 23.205 11.6506 23.48 11.9818 23.6712C12.3129 23.8624 12.6886 23.963 13.0709 23.963C13.4533 23.963 13.829 23.8624 14.1601 23.6712C14.4913 23.48 14.7663 23.205 14.9575 22.8739",
    stroke: "#6A7282",
    strokeWidth: 2.17847,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55308 16.6936C3.41078 16.8496 3.31688 17.0435 3.28279 17.2519C3.2487 17.4602 3.27589 17.674 3.36105 17.8671C3.44622 18.0603 3.58568 18.2246 3.76249 18.34C3.93929 18.4553 4.14582 18.5168 4.35693 18.517H21.7847C21.9958 18.5171 22.2023 18.4558 22.3793 18.3406C22.5562 18.2255 22.6958 18.0614 22.7812 17.8684C22.8666 17.6753 22.8941 17.4616 22.8602 17.2532C22.8264 17.0449 22.7328 16.8508 22.5907 16.6947C21.142 15.2014 19.6062 13.6143 19.6062 8.71387C19.6062 6.98058 18.9177 5.31827 17.692 4.09264C16.4664 2.86702 14.8041 2.17847 13.0708 2.17847C11.3375 2.17847 9.6752 2.86702 8.44958 4.09264C7.22395 5.31827 6.5354 6.98058 6.5354 8.71387C6.5354 13.6143 4.99849 15.2014 3.55308 16.6936Z",
    stroke: "#6A7282",
    strokeWidth: 2.17847,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarm);
export default __webpack_public_path__ + "static/media/ic_alarm.2e57ec2a985a1d764c54874980fb3a9a.svg";
export { ForwardRef as ReactComponent };